import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from 'constants/registrationStep';

/**
 * APIキーテンプレート登録画面の状態
 */
interface RegistrationState {
  /** 登録モーダル表示フラグ */
  isOpen: boolean;
  /** 登録ステップ */
  step: RegistrationStep;
}

/**
 * APIキーテンプレート登録画面の初期状態
 */
const initialState: RegistrationState = {
  step: REGISTRATION_STEP.INPUT,
  isOpen: false,
};

/**
 * APIキーテンプレート登録画面の slice(reducer + action)
 */
export const registrationSlice = createSlice({
  name: 'registrationComponent',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (state) => {
      state.isOpen = true;
    },
    updateStep: (
      state,
      { payload }: PayloadAction<RegistrationState['step']>,
    ) => ({
      ...state,
      step: payload,
    }),
  },
});

/**
 * APIキーテンプレート登録画面の action
 */
export const registrationActions = registrationSlice.actions;

/**
 * APIキーテンプレート登録画面の selectors
 */
export const registrationSelectors = {
  isOpenModal: (state: RootState) => state.apiKeyTemplate.registration.isOpen,
  currentModalStep: (state: RootState) =>
    state.apiKeyTemplate.registration.step,
} as const;
